export default {
    "statuecardtype":[
        {
            "code": "1",
            "keyword": "deputizecardtype",
            "name": "身份证"
        },
        {
            "code": "2",
            "keyword": "deputizecardtype",
            "name": "军官证"
        },
        {
            "code": "2011",
            "keyword": "deputizecardtype",
            "name": "护照"
        },
        {
            "code": "2015",
            "keyword": "deputizecardtype",
            "name": "外国人永久居留证"
        },
        {
            "code": "9232",
            "keyword": "deputizecardtype",
            "name": "台港澳居民通行证"
        },
        {
            "code": "2012",
            "keyword": "deputizecardtype",
            "name": "其他"
        },
    ],


    "deputizecardtype":[
        {
            "code": "3",
            "keyword": "deputizecardtype",
            "name": "身份证"
        },
        {
            "code": "4",
            "keyword": "deputizecardtype",
            "name": "军官证"
        },
        {
            "code": "2013",
            "keyword": "deputizecardtype",
            "name": "护照"
        },
        {
            "code": "2016",
            "keyword": "deputizecardtype",
            "name": "外国人永久居留证"
        },
        {
            "code": "9233",
            "keyword": "deputizecardtype",
            "name": "台港澳居民通行证"
        },
        {
            "code": "2036",
            "keyword": "deputizecardtype",
            "name": "台港澳居民通行证"
        },
        {
            "code": "2014",
            "keyword": "deputizecardtype",
            "name": "其他"
        },
    ],


    "structure":[
        {
            "code": "92009500",
            "keyword": "structure",
            "name": "公寓式"
        },
        {
            "code": "92009501",
            "keyword": "structure",
            "name": "楼中楼"
        },
        {
            "code": "92009502",
            "keyword": "structure",
            "name": "豪宅"
        },
        {
            "code": "92009503",
            "keyword": "structure",
            "name": "独栋别墅"
        },
        {
            "code": "92009504",
            "keyword": "structure",
            "name": "钢筋混凝土"
        },
        {
            "code": "92009505",
            "keyword": "structure",
            "name": "混合"
        },
        {
            "code": "92009506",
            "keyword": "structure",
            "name": "其他"
        },
        {
            "code": "92009507",
            "keyword": "structure",
            "name": "框架"
        },
    ],
    "clearingbank":[
        {
            "code": "1",
            "keyword": "clearingbank",
            "name": "工商银行"
        },
        {
            "code": "2",
            "keyword": "clearingbank",
            "name": "建行银行"
        },
        {
            "code": "3",
            "keyword": "clearingbank",
            "name": "农业银行"
        },
        {
            "code": "4",
            "keyword": "clearingbank",
            "name": "中国银行"
        },
        {
            "code": "5",
            "keyword": "clearingbank",
            "name": "邮储银行"
        },
        {
            "code": "6",
            "keyword": "clearingbank",
            "name": "中原银行"
        },
        {
            "code": "7",
            "keyword": "clearingbank",
            "name": "农信联社"
        },
        {
            "code": "11",
            "keyword": "clearingbank",
            "name": "郑州银行"
        },
    ],


    "housesalesdto":[
        {
            "code": "94009400",
            "keyword": "housesalesdto",
            "name": "预售"
        },
        {
            "code": "94009401",
            "keyword": "housesalesdto",
            "name": "现售"
        },
    ],
    "buildorganid":[

        {
            "code": "10001",
            "keyword": "buildorganid",
            "name": "市直管理部"
        },
        {
            "code": "10002",
            "keyword": "buildorganid",
            "name": "川汇区管理部"
        }
        ,
        {
            "code": "10003",
            "keyword": "buildorganid",
            "name": "项城市管理部"
        }
        ,
        {
            "code": "10004",
            "keyword": "buildorganid",
            "name": "商水县管理部"
        }
        ,
        {
            "code": "10005",
            "keyword": "buildorganid",
            "name": "太康县管理部"
        }
        ,
        {
            "code": "10006",
            "keyword": "buildorganid",
            "name": "西华县管理部"
        }
        ,
        {
            "code": "10007",
            "keyword": "buildorganid",
            "name": "郸城县管理部"
        }
        ,
        {
            "code": "10008",
            "keyword": "buildorganid",
            "name": "扶沟县管理部"
        },
        {
            "code": "10009",
            "keyword": "buildorganid",
            "name": "淮阳县管理部"
        },
        {
            "code": "10010",
            "keyword": "buildorganid",
            "name": "沈丘县管理部"
        },
        {
            "code": "10011",
            "keyword": "buildorganid",
            "name": "黄泛区管理部"
        },
        {
            "code": "10012",
            "keyword": "buildorganid",
            "name": "周口监狱管理部"
        }
    ],
    "sfqytypeenumitem":[
        {
            "code": "50050",
            "keyword": "sfqytypeenumitem",
            "name": "房地产开发企业"
        },
        {
            "code": "50051",
            "keyword": "sfqytypeenumitem",
            "name": "房地产中介服务机构"
        }
    ],
    "bjyy": [{
            "code": "04",
            "enumid": 604,
            "keyword": "bjyy",
            "name": "缓缴期满"
        },
        {
            "code": "05",
            "enumid": 605,
            "keyword": "bjyy",
            "name": "其他"
        },
        {
            "code": "07",
            "enumid": 607,
            "keyword": "bjyy",
            "name": "逾期"
        },
        {
            "code": "08",
            "enumid": 608,
            "keyword": "bjyy",
            "name": "少缴"
        },
        {
            "code": "09",
            "enumid": 609,
            "keyword": "bjyy",
            "name": "历史性欠缴"
        },
        {
            "code": "10",
            "enumid": 610,
            "keyword": "bjyy",
            "name": "缴存基数不实"
        },
        {
            "code": "11",
            "enumid": 611,
            "keyword": "bjyy",
            "name": "缴存人数不实"
        },
        {
            "code": "12",
            "enumid": 612,
            "keyword": "bjyy",
            "name": "补发工资"
        },
        {
            "code": "13",
            "enumid": 613,
            "keyword": "bjyy",
            "name": "补发一次性奖金"
        },
        {
            "code": "14",
            "enumid": 614,
            "keyword": "bjyy",
            "name": "跨年度发放奖金"
        },
        {
            "code": "15",
            "enumid": 615,
            "keyword": "bjyy",
            "name": "滞缴"
        },
        {
            "code": "16",
            "enumid": 616,
            "keyword": "bjyy",
            "name": "提高贷款额度"
        },
        {
            "code": "17",
            "enumid": 617,
            "keyword": "bjyy",
            "name": "单位给部分人缴存"
        }
    ],
    "cdgx": [{
            "code": "1",
            "enumid": 421020,
            "keyword": "loanapply_relation",
            "name": "配偶"
        },
        {
            "code": "2",
            "enumid": 420052,
            "keyword": "loanapply_relation",
            "name": "子"
        },
        {
            "code": "3",
            "enumid": 421030,
            "keyword": "loanapply_relation",
            "name": "女"
        },
        {
            "code": "4",
            "enumid": 420051,
            "keyword": "loanapply_relation",
            "name": "孙子女"
        },
        {
            "code": "5",
            "enumid": 410047,
            "keyword": "loanapply_relation",
            "name": "父母"
        },
        {
            "code": "6",
            "enumid": 421052,
            "keyword": "loanapply_relation",
            "name": "祖父母"
        },
        {
            "code": "7",
            "enumid": 410049,
            "keyword": "loanapply_relation",
            "name": "兄弟姐妹"
        },
        {
            "code": "8",
            "enumid": 420048,
            "keyword": "loanapply_relation",
            "name": "恋人"
        },
        {
            "code": "9",
            "enumid": 420053,
            "keyword": "loanapply_relation",
            "name": "其他"
        }
    ],
    "dklx": [{
            "code": "05",
            "enumid": 51,
            "keyword": "loanapply_loantype",
            "name": "贴息组合贷款"
        },
        {
            "code": "01",
            "enumid": 47,
            "keyword": "loanapply_loantype",
            "name": "公积金贷款"
        },
        {
            "code": "02",
            "enumid": 48,
            "keyword": "loanapply_loantype",
            "name": "组合贷款"
        },
        {
            "code": "03",
            "enumid": 50,
            "keyword": "loanapply_loantype",
            "name": "贴息贷款"
        },
        {
            "code": "04",
            "enumid": 49,
            "keyword": "loanapply_loantype",
            "name": "商业贷款转公积金贷款"
        }
    ],
    "dkyt": [{
            "code": "01",
            "enumid": 93000001,
            "keyword": "loan_uses",
            "name": "购商品房"
        },
        {
            "code": "02",
            "enumid": 93000002,
            "keyword": "loan_uses",
            "name": "建造"
        },
        {
            "code": "03",
            "enumid": 93000003,
            "keyword": "loan_uses",
            "name": "大修"
        },
        {
            "code": "04",
            "enumid": 93000004,
            "keyword": "loan_uses",
            "name": "租房"
        },
        {
            "code": "05",
            "enumid": 93000005,
            "keyword": "loan_uses",
            "name": "购二手房"
        },
        {
            "code": "06",
            "enumid": 93000006,
            "keyword": "loan_uses",
            "name": "自建住房"
        },
        {
            "code": "07",
            "enumid": 93000007,
            "keyword": "loan_uses",
            "name": "集资建房"
        }
    ],
    "dkywmxlx": [{
            "code": "01",
            "enumid": 1501,
            "keyword": "dkywmxlx",
            "name": "贷款发放"
        },
        {
            "code": "02",
            "enumid": 1502,
            "keyword": "dkywmxlx",
            "name": "正常还款"
        },
        {
            "code": "03",
            "enumid": 1503,
            "keyword": "dkywmxlx",
            "name": "提取还款"
        },
        {
            "code": "04",
            "enumid": 1504,
            "keyword": "dkywmxlx",
            "name": "逾期还款"
        },
        {
            "code": "05",
            "enumid": 1505,
            "keyword": "dkywmxlx",
            "name": "公积金提取还款"
        },
        {
            "code": "06",
            "enumid": 1506,
            "keyword": "dkywmxlx",
            "name": "结清"
        },
        {
            "code": "07",
            "enumid": 1507,
            "keyword": "dkywmxlx",
            "name": "贷款展期"
        },
        {
            "code": "08",
            "enumid": 1508,
            "keyword": "dkywmxlx",
            "name": "贷款缩期"
        },
        {
            "code": "09",
            "enumid": 1509,
            "keyword": "dkywmxlx",
            "name": "核销"
        },
        {
            "code": "10",
            "enumid": 1511,
            "keyword": "dkywmxlx",
            "name": "结转逾期"
        },
        {
            "code": "99",
            "enumid": 1510,
            "keyword": "dkywmxlx",
            "name": "其他"
        }
    ],
    "dwjjlx": [{
            "code": "100",
            "enumid": 1701,
            "keyword": "cust_7",
            "name": "内资"
        },
        {
            "code": "110",
            "enumid": 1702,
            "keyword": "cust_7",
            "name": "国有全资"
        },
        {
            "code": "120",
            "enumid": 1703,
            "keyword": "cust_7",
            "name": "集体全资"
        },
        {
            "code": "130",
            "enumid": 1704,
            "keyword": "cust_7",
            "name": "股份合作"
        },
        {
            "code": "140",
            "enumid": 1705,
            "keyword": "cust_7",
            "name": "联营"
        },
        {
            "code": "141",
            "enumid": 1706,
            "keyword": "cust_7",
            "name": "国有联营"
        },
        {
            "code": "142",
            "enumid": 1707,
            "keyword": "cust_7",
            "name": "集体联营"
        },
        {
            "code": "143",
            "enumid": 1708,
            "keyword": "cust_7",
            "name": "国有与集体联营"
        },
        {
            "code": "149",
            "enumid": 1709,
            "keyword": "cust_7",
            "name": "其他联营"
        },
        {
            "code": "150",
            "enumid": 1710,
            "keyword": "cust_7",
            "name": "有限责任(公司)"
        },
        {
            "code": "151",
            "enumid": 1711,
            "keyword": "cust_7",
            "name": "国有独资(公司)"
        },
        {
            "code": "159",
            "enumid": 1712,
            "keyword": "cust_7",
            "name": "其他有限责任(公司)"
        },
        {
            "code": "160",
            "enumid": 1713,
            "keyword": "cust_7",
            "name": "股份有限(公司)"
        },
        {
            "code": "170",
            "enumid": 1714,
            "keyword": "cust_7",
            "name": "私有"
        },
        {
            "code": "171",
            "enumid": 1715,
            "keyword": "cust_7",
            "name": "私有独资"
        },
        {
            "code": "172",
            "enumid": 1716,
            "keyword": "cust_7",
            "name": "私有合伙"
        },
        {
            "code": "173",
            "enumid": 1717,
            "keyword": "cust_7",
            "name": "私营有限责任(公司)"
        },
        {
            "code": "174",
            "enumid": 1718,
            "keyword": "cust_7",
            "name": "私营股份有限(公司)"
        },
        {
            "code": "175",
            "enumid": 1719,
            "keyword": "cust_7",
            "name": "一个体经营"
        },
        {
            "code": "179",
            "enumid": 1720,
            "keyword": "cust_7",
            "name": "其他私有"
        },
        {
            "code": "190",
            "enumid": 1721,
            "keyword": "cust_7",
            "name": "其他内资"
        },
        {
            "code": "200",
            "enumid": 1722,
            "keyword": "cust_7",
            "name": "港、澳、台投资"
        },
        {
            "code": "210",
            "enumid": 1723,
            "keyword": "cust_7",
            "name": "内地 和港、澳、台合资"
        },
        {
            "code": "220",
            "enumid": 1724,
            "keyword": "cust_7",
            "name": "内地 和港、澳、台合作"
        },
        {
            "code": "230",
            "enumid": 1725,
            "keyword": "cust_7",
            "name": "港、澳、台独资"
        },
        {
            "code": "240",
            "enumid": 1726,
            "keyword": "cust_7",
            "name": "港、澳、台投资股份有限(公司)"
        },
        {
            "code": "290",
            "enumid": 1727,
            "keyword": "cust_7",
            "name": "其他港、澳、台投资"
        },
        {
            "code": "300",
            "enumid": 1728,
            "keyword": "cust_7",
            "name": "国外投资"
        },
        {
            "code": "310",
            "enumid": 1729,
            "keyword": "cust_7",
            "name": "中外合资"
        },
        {
            "code": "320",
            "enumid": 1730,
            "keyword": "cust_7",
            "name": "中外合作"
        },
        {
            "code": "330",
            "enumid": 1731,
            "keyword": "cust_7",
            "name": "外资"
        },
        {
            "code": "340",
            "enumid": 1732,
            "keyword": "cust_7",
            "name": "国外投资股份有限(公司)"
        },
        {
            "code": "390",
            "enumid": 1733,
            "keyword": "cust_7",
            "name": "其他国外投资"
        },
        {
            "code": "900",
            "enumid": 1734,
            "keyword": "cust_7",
            "name": "其他"
        }
    ],
    "dwlsgx": [{
            "code": "10",
            "enumid": 360001,
            "keyword": "cust_6",
            "name": "中央"
        },
        {
            "code": "20",
            "enumid": 360002,
            "keyword": "cust_6",
            "name": "省"
        },
        {
            "code": "40",
            "enumid": 360003,
            "keyword": "cust_6",
            "name": "市、地区"
        },
        {
            "code": "50",
            "enumid": 360004,
            "keyword": "cust_6",
            "name": "县"
        },
        {
            "code": "60",
            "enumid": 360005,
            "keyword": "cust_6",
            "name": "街道、镇、乡"
        },
        {
            "code": "71",
            "enumid": 360010,
            "keyword": "cust_6",
            "name": "居民委员会"
        },
        {
            "code": "90",
            "enumid": 360012,
            "keyword": "cust_6",
            "name": "其他"
        }
    ],
    "dwsshy": [{
            "code": "A",
            "enumid": 5,
            "keyword": "cust_3",
            "name": "农、林、牧、渔业"
        },
        {
            "code": "B",
            "enumid": 6,
            "keyword": "cust_3",
            "name": "采矿业"
        },
        {
            "code": "C",
            "enumid": 7,
            "keyword": "cust_3",
            "name": "制造业"
        },
        {
            "code": "D",
            "enumid": 8,
            "keyword": "cust_3",
            "name": "电力、热力、燃气及水生产和供应业"
        },
        {
            "code": "E",
            "enumid": 9,
            "keyword": "cust_3",
            "name": "建筑业"
        },
        {
            "code": "F",
            "enumid": 83,
            "keyword": "cust_3",
            "name": "批发和零售业"
        },
        {
            "code": "G",
            "enumid": 10,
            "keyword": "cust_3",
            "name": "交通运输、仓储和邮政业"
        },
        {
            "code": "H",
            "enumid": 84,
            "keyword": "cust_3",
            "name": "住宿和餐饮业"
        },
        {
            "code": "I",
            "enumid": 11,
            "keyword": "cust_3",
            "name": "信息传输、软件和信息技术服务业"
        },
        {
            "code": "J",
            "enumid": 85,
            "keyword": "cust_3",
            "name": "金融业"
        },
        {
            "code": "K",
            "enumid": 86,
            "keyword": "cust_3",
            "name": "房地产业"
        },
        {
            "code": "L",
            "enumid": 102,
            "keyword": "cust_3",
            "name": "租赁和商务服务业"
        },
        {
            "code": "M",
            "enumid": 87,
            "keyword": "cust_3",
            "name": "科学研究和技术服务业"
        },
        {
            "code": "N",
            "enumid": 88,
            "keyword": "cust_3",
            "name": "水利、环境和公共设施管理业"
        },
        {
            "code": "O",
            "enumid": 89,
            "keyword": "cust_3",
            "name": "居民服务、修理和其他服务业"
        },
        {
            "code": "P",
            "enumid": 90,
            "keyword": "cust_3",
            "name": "教育"
        },
        {
            "code": "Q",
            "enumid": 91,
            "keyword": "cust_3",
            "name": "卫生和社会工作"
        },
        {
            "code": "R",
            "enumid": 92,
            "keyword": "cust_3",
            "name": "文化、体育和娱乐业"
        },
        {
            "code": "S",
            "enumid": 93,
            "keyword": "cust_3",
            "name": "公共管理、社会保障和社会组织"
        },
        {
            "code": "T",
            "enumid": 94,
            "keyword": "cust_3",
            "name": "国际组织"
        },
        {
            "code": "Z",
            "enumid": 101,
            "keyword": "cust_3",
            "name": "其它经济行业"
        }
    ],
    "dwxz": [{
            "code": "01",
            "enumid": 12,
            "keyword": "cust_4",
            "name": "国家机关、事业单位"
        },
        {
            "code": "02",
            "enumid": 13,
            "keyword": "cust_4",
            "name": "国有企业"
        },
        {
            "code": "03",
            "enumid": 14,
            "keyword": "cust_4",
            "name": "城镇集体企业"
        },
        {
            "code": "04",
            "enumid": 15,
            "keyword": "cust_4",
            "name": "外商投资企业"
        },
        {
            "code": "05",
            "enumid": 95,
            "keyword": "cust_4",
            "name": "城镇私营企业及其他城镇企业"
        },
        {
            "code": "06",
            "enumid": 96,
            "keyword": "cust_4",
            "name": "民办非企业单位、社会团体"
        },
        {
            "code": "07",
            "enumid": 97,
            "keyword": "cust_4",
            "name": "其他"
        }
    ],
    "dwzhzt": [{
            "code": "01",
            "enumid": 1,
            "keyword": "dwzhzt",
            "name": "正常"
        },
        {
            "code": "02",
            "enumid": 13,
            "keyword": "dwzhzt",
            "name": "开户未启用"
        },
        {
            "code": "03",
            "enumid": 21,
            "keyword": "dwzhzt",
            "name": "缓缴"
        },
        {
            "code": "04",
            "enumid": 31,
            "keyword": "dwzhzt",
            "name": "销户"
        },
        {
            "code": "05",
            "enumid": 11,
            "keyword": "dwzhzt",
            "name": "封存"
        },
        {
            "code": "06",
            "enumid": 12,
            "keyword": "dwzhzt",
            "name": "待调基"
        },
        {
            "code": "07",
            "enumid": 6,
            "keyword": "dwzhzt",
            "name": "低比例缴存"
        },
        {
            "code": "08",
            "enumid": 7,
            "keyword": "dwzhzt",
            "name": "降低比例到期"
        },
        {
            "code": "09",
            "enumid": 14,
            "keyword": "dwzhzt",
            "name": "停缴到期"
        },
        {
            "code": "10",
            "enumid": 22,
            "keyword": "dwzhzt",
            "name": "缓缴到期"
        },
        {
            "code": "11",
            "enumid": 8,
            "keyword": "dwzhzt",
            "name": "降低比例申请"
        },
        {
            "code": "12",
            "enumid": 15,
            "keyword": "dwzhzt",
            "name": "停缴申请"
        },
        {
            "code": "13",
            "enumid": 23,
            "keyword": "dwzhzt",
            "name": "缓缴申请"
        }
    ],
    "dwzxyy": [{
            "code": "01",
            "enumid": 380001,
            "keyword": "dwxhyy",
            "name": "撤销"
        },
        {
            "code": "02",
            "enumid": 380002,
            "keyword": "dwxhyy",
            "name": "合并"
        },
        {
            "code": "03",
            "enumid": 380003,
            "keyword": "dwxhyy",
            "name": "解散"
        },
        {
            "code": "04",
            "enumid": 380004,
            "keyword": "dwxhyy",
            "name": "破产"
        },
        {
            "code": "05",
            "enumid": 380005,
            "keyword": "dwxhyy",
            "name": "分立"
        },
        {
            "code": "06",
            "enumid": 380006,
            "keyword": "dwxhyy",
            "name": "迁出"
        },
        {
            "code": "99",
            "enumid": 380007,
            "keyword": "dwxhyy",
            "name": "其他"
        },
        {
            "code": "99",
            "enumid": 380008,
            "keyword": "dwxhyy",
            "name": "其他（单位终止）"
        }
    ],
    "fcyy": [
        {
            "code": "01",
            "enumid": 530055,
            "keyword": "convergeChange_type",
            "name": "终止劳动关系-辞职"
        },
        {
            "code": "03",
            "enumid": 530057,
            "keyword": "convergeChange_type",
            "name": "终止劳动关系-开除"
        },
        {
            "code": "04",
            "enumid": 530058,
            "keyword": "convergeChange_type",
            "name": "终止劳动关系-解除劳动(聘用)合同"
        },
        {
            "code": "05",
            "enumid": 530059,
            "keyword": "convergeChange_type",
            "name": "终止劳动关系-劳动(聘用)合同期满"
        },
        {
            "code": "06",
            "enumid": 530060,
            "keyword": "convergeChange_type",
            "name": "终止劳动关系-其它"
        },
        {
            "code": "13",
            "enumid": 530067,
            "keyword": "convergeChange_type",
            "name": "个人年满男60周岁、女55周岁，有住房公积金贷款债务或住房公积金贷款保证责任"
        },
        {
            "code": "08",
            "enumid": 530062,
            "keyword": "convergeChange_type",
            "name": "单位合并、分立后，新单位尚未办理住房公积金缴存登记"
        },
        {
            "code": "09",
            "enumid": 530063,
            "keyword": "convergeChange_type",
            "name": "单位在撤销、解散、破产后，职工没有在新单位缴存住房公积金或没有以个人身份缴存住房公积金"
        },
        {
            "code": "10",
            "enumid": 530064,
            "keyword": "convergeChange_type",
            "name": "因停薪留职等合法合规原因，单位停发工资"
        },
        {
            "code": "14",
            "enumid": 530068,
            "keyword": "convergeChange_type",
            "name": "离退休"
        },
        {
            "code": "11",
            "enumid": 530065,
            "keyword": "convergeChange_type",
            "name": "发生职工应当办理住房公积金转移、销户提取情形"
        },
        {
            "code": "12",
            "enumid": 530066,
            "keyword": "convergeChange_type",
            "name": "个人申请不再缴存住房公积金，年龄不满：男60周岁、女55周岁"
        },
        {
            "code": "02",
            "enumid": 530056,
            "keyword": "convergeChange_type",
            "name": "终止劳动关系-辞退"
        },
        {
            "code": "07",
            "enumid": 530061,
            "keyword": "convergeChange_type",
            "name": "职工在管辖区内调转工作，调入单位尚未办理住房公积金缴存登记"
        }
    ],
    "gfzl": [{
            "code": "01",
            "enumid": 360043,
            "keyword": "loanapply_housetype",
            "name": "商品房"
        },
        {
            "code": "16",
            "enumid": 360045,
            "keyword": "loanapply_housetype",
            "name": "二手房"
        },
        {
            "code": "03",
            "enumid": 360046,
            "keyword": "loanapply_housetype",
            "name": "自建住房"
        },
        {
            "code": "53",
            "enumid": 360057,
            "keyword": "loanapply_housetype",
            "name": "集资建房"
        }
    ],
    "gjhtqywmx": [{
            "code": "01",
            "enumid": 501,
            "keyword": "gjhtqywmx",
            "name": "汇缴"
        },
        {
            "code": "02",
            "enumid": 502,
            "keyword": "gjhtqywmx",
            "name": "补缴"
        },
        {
            "code": "03",
            "enumid": 503,
            "keyword": "gjhtqywmx",
            "name": "开户"
        },
        {
            "code": "04",
            "enumid": 504,
            "keyword": "gjhtqywmx",
            "name": "启封"
        },
        {
            "code": "05",
            "enumid": 505,
            "keyword": "gjhtqywmx",
            "name": "封存"
        },
        {
            "code": "06",
            "enumid": 506,
            "keyword": "gjhtqywmx",
            "name": "内部转移"
        },
        {
            "code": "07",
            "enumid": 507,
            "keyword": "gjhtqywmx",
            "name": "外部转移"
        },
        {
            "code": "08",
            "enumid": 508,
            "keyword": "gjhtqywmx",
            "name": "外部转入"
        },
        {
            "code": "09",
            "enumid": 509,
            "keyword": "gjhtqywmx",
            "name": "年终结息"
        },
        {
            "code": "10",
            "enumid": 510,
            "keyword": "gjhtqywmx",
            "name": "基数调整"
        },
        {
            "code": "11",
            "enumid": 511,
            "keyword": "gjhtqywmx",
            "name": "部分提取"
        },
        {
            "code": "12",
            "enumid": 512,
            "keyword": "gjhtqywmx",
            "name": "销户提取"
        },
        {
            "code": "13",
            "enumid": 513,
            "keyword": "gjhtqywmx",
            "name": "缓缴处理"
        },
        {
            "code": "14",
            "enumid": 514,
            "keyword": "gjhtqywmx",
            "name": "冻结"
        },
        {
            "code": "15",
            "enumid": 515,
            "keyword": "gjhtqywmx",
            "name": "解冻"
        },
        {
            "code": "99",
            "enumid": 516,
            "keyword": "gjhtqywmx",
            "name": "其他"
        }
    ],
    "grckzhkhyhdm": [
        {
            "ext1": "01",
            "enumid": 1,
            "code_1": "102",
            "code": "102000",
            "keyword": "grckzhkhyhdm",
            "name": "工商银行",
            "bankomCode":"102000"
        },
        {
            "ext1": "02",
            "enumid": 2,
            "code_1": "105",
            "code": "105000",
            "keyword": "grckzhkhyhdm",
            "name": "建设银行",
            "bankomCode":"105000"
        },
        {
            "ext1": "03",
            "enumid": 3,
            "code_1": "103",
            "code": "103000",
            "keyword": "grckzhkhyhdm",
            "name": "农业银行",
            "bankomCode":"103000"
        },
        {
            "ext1": "04",
            "enumid": 4,
            "code_1": "104",
            "code": "104000",
            "keyword": "grckzhkhyhdm",
            "name": "中国银行",
            "bankomCode":"104000"
        },
        {
            "ext1": "05",
            "enumid": 5,
            "code_1": "403",
            "code": "313009",
            "keyword": "grckzhkhyhdm",
            "name": "邮储银行",
            "bankomCode":"313009"
        },
        {
            "ext1": "06",
            "enumid": 6,
            "code_1": "313",
            "code": "313035",
            "keyword": "grckzhkhyhdm",
            "name": "中原银行",
            "bankomCode":"313035"
        },
        {
            "ext1": "07",
            "enumid": 7,
            "code_1": "402",
            "code": "313050",
            "keyword": "grckzhkhyhdm",
            "name": "农信联社",
            "bankomCode":"313050"
        },
        {
            "ext1":"11",
            "code_1": "313",
            "code":"313097",
            "enumid":11,
            "keyword":"grckzhkhyhdm",
            "name":"郑州银行",
            "bankomCode":"313097"
        },
        {
            "ext1": "08",
            "enumid": 8,
            "code_1": "1",
            "code": "000000",
            "keyword": "grckzhkhyhdm",
            "name": "其他",
            "bankomCode":"000000"
        }

    ],
    "grzhzt": [{
            "code": "01",
            "enumid": 70007,
            "keyword": "personal_status",
            "name": "正常"
        },
        {
            "code": "02",
            "enumid": 70008,
            "keyword": "personal_status",
            "name": "封存"
        },
        {
            "code": "05",
            "enumid": 70009,
            "keyword": "personal_status",
            "name": "销户"
        }
    ],
    "hkfs": [{
            "code": "01",
            "enumid": 1,
            "keyword": "hkfs",
            "name": "等额本息"
        },
        {
            "code": "02",
            "enumid": 2,
            "keyword": "hkfs",
            "name": "等额本金"
        },
        {
            "code": "03",
            "enumid": 3,
            "keyword": "hkfs",
            "name": "一次还本付息"
        },
        // {
        //     "code": "04",
        //     "enumid": 5,
        //     "keyword": "hkfs",
        //     "name": "自由还款方式"
        // },
        // {
        //     "code": "05",
        //     "enumid": 4,
        //     "keyword": "hkfs",
        //     "name": "等本等息"
        // }
    ],
    "hyzk": [{
            "code": "10",
            "enumid": 53,
            "keyword": "loanapply_marrytype",
            "name": "未婚"
        },
        {
            "code": "20",
            "enumid": 54,
            "keyword": "loanapply_marrytype",
            "name": "已婚"
        },
        {
            "code": "40",
            "enumid": 55,
            "keyword": "loanapply_marrytype",
            "name": "离婚"
        },
        {
            "code": "30",
            "enumid": 100,
            "keyword": "loanapply_marrytype",
            "name": "丧偶"
        },
        {
            "code": "90",
            "enumid": 113,
            "keyword": "loanapply_marrytype",
            "name": "未说明的婚姻状况"
        }
    ],
    "tqyy": [{
            "code": "10",
            "enumid": 10,
            "keyword": "tqyy",
            "name": "购房不贷款提取"
        },
        {
            "code": "11",
            "enumid": 11,
            "keyword": "tqyy",
            "name": "购二手房"
        },
        {
            "code": "12",
            "enumid": 12,
            "keyword": "tqyy",
            "name": "自建房"
        },
        {
            "code": "13",
            "enumid": 13,
            "keyword": "tqyy",
            "name": "修建住房"
        },
        {
            "code": "14",
            "enumid": 14,
            "keyword": "tqyy",
            "name": "购房贷款首付提取"
        },
        {
            "code": "15",
            "enumid": 15,
            "keyword": "tqyy",
            "name": "装修"
        },
        {
            "code": "20",
            "enumid": 20,
            "keyword": "tqyy",
            "name": "偿还公积金贷款"
        },
        {
            "code": "21",
            "enumid": 21,
            "keyword": "tqyy",
            "name": "偿还商业贷款提取"
        },
        {
            "code": "22",
            "enumid": 22,
            "keyword": "tqyy",
            "name": "提前偿还公积金贷款提取"
        },
        {
            "code": "25",
            "enumid": 25,
            "keyword": "tqyy",
            "name": "偿还异地贷款提取"
        },
        {
            "code": "30",
            "enumid": 30,
            "keyword": "tqyy",
            "name": "租房"
        },
        {
            "code": "31",
            "enumid": 31,
            "keyword": "tqyy",
            "name": "物业费"
        },
        {
            "code": "40",
            "enumid": 40,
            "keyword": "tqyy",
            "name": "其他住房消费"
        },
        {
            "code": "50",
            "enumid": 50,
            "keyword": "tqyy",
            "name": "退休"
        },
        {
            "code": "51",
            "enumid": 51,
            "keyword": "tqyy",
            "name": "退休（部分）"
        },
        {
            "code": "60",
            "enumid": 60,
            "keyword": "tqyy",
            "name": "完全丧失按劳能力"
        },
        {
            "code": "70",
            "enumid": 70,
            "keyword": "tqyy",
            "name": "出境提取"
        },
        {
            "code": "71",
            "enumid": 71,
            "keyword": "tqyy",
            "name": "调出(销户)"
        },
        {
            "code": "80",
            "enumid": 80,
            "keyword": "tqyy",
            "name": "离职未再就业"
        },
        {
            "code": "83",
            "enumid": 83,
            "keyword": "tqyy",
            "name": "低保"
        },
        {
            "code": "84",
            "enumid": 84,
            "keyword": "tqyy",
            "name": "重大疾病"
        },
        {
            "code": "85",
            "enumid": 85,
            "keyword": "tqyy",
            "name": "其他(部分)"
        },
        {
            "code": "86",
            "enumid": 86,
            "keyword": "tqyy",
            "name": "调账"
        },
        {
            "code": "88",
            "enumid": 88,
            "keyword": "tqyy",
            "name": "法院(销户)"
        },
        {
            "code": "90",
            "enumid": 90,
            "keyword": "tqyy",
            "name": "其他(销户)"
        },
        {
            "code": "91",
            "enumid": 91,
            "keyword": "tqyy",
            "name": "死亡"
        },
        {
            "code": "92",
            "enumid": 92,
            "keyword": "tqyy",
            "name": "封存期满提取"
        },
        {
            "code": "94",
            "enumid": 94,
            "keyword": "tqyy",
            "name": "法院(部分)"
        }
    ],
    "xingbie": [{
            "code": "1",
            "enumid": 21,
            "keyword": "common_sex",
            "name": "男"
        },
        {
            "code": "2",
            "enumid": 22,
            "keyword": "common_sex",
            "name": "女"
        },
        {
            "code": "3",
            "enumid": 98,
            "keyword": "common_sex",
            "name": "未知的性别"
        },
        {
            "code": "4",
            "enumid": 99,
            "keyword": "common_sex",
            "name": "未说明的性别"
        }
    ],
    "xueli": [{
            "code": "10",
            "enumid": 111,
            "keyword": "common_record",
            "name": "研究生教育"
        },
        {
            "code": "20",
            "enumid": 28,
            "keyword": "common_record",
            "name": "大学本科教育"
        },
        {
            "code": "30",
            "enumid": 27,
            "keyword": "common_record",
            "name": "大学专科教育"
        },
        {
            "code": "40",
            "enumid": 26,
            "keyword": "common_record",
            "name": "中等职业教育"
        },
        {
            "code": "60",
            "enumid": 109,
            "keyword": "common_record",
            "name": "普通高级中学教育"
        },
        {
            "code": "70",
            "enumid": 25,
            "keyword": "common_record",
            "name": "初级中学教育"
        },
        {
            "code": "80",
            "enumid": 112,
            "keyword": "common_record",
            "name": "小学教育"
        },
        {
            "code": "90",
            "enumid": 110,
            "keyword": "common_record",
            "name": "其他"
        }
    ],
    "ywlx": [{
            "enumid": "00",
            "code": "0",
            "keyword": "ywlx",
            "name": "期初"
        },
        {
            "enumid": "0101",
            "code": "101",
            "keyword": "ywlx",
            "name": "按月缴存"
        },
        {
            "enumid": "0102",
            "code": "102",
            "keyword": "ywlx",
            "name": "缴预缴户"
        },
        {
            "enumid": "0103",
            "code": "103",
            "keyword": "ywlx",
            "name": "预缴户转入"
        },
        {
            "enumid": "0106",
            "code": "104",
            "keyword": "ywlx",
            "name": "缴财政专户"
        },
        {
            "enumid": "0107",
            "code": "105",
            "keyword": "ywlx",
            "name": "财政专户资金调整"
        },
        {
            "enumid": "0112",
            "code": "106",
            "keyword": "ywlx",
            "name": "部分提取"
        },
        {
            "enumid": "0111",
            "code": "107",
            "keyword": "ywlx",
            "name": "提取"
        },
        {
            "enumid": "0131",
            "code": "108",
            "keyword": "ywlx",
            "name": "内部转移"
        },
        {
            "enumid": "0133",
            "code": "109",
            "keyword": "ywlx",
            "name": "外部转入"
        },
        {
            "enumid": "0132",
            "code": "110",
            "keyword": "ywlx",
            "name": "外部转出"
        },
        {
            "enumid": "0135",
            "code": "111",
            "keyword": "ywlx",
            "name": "异地调入"
        },
        {
            "enumid": "0134",
            "code": "112",
            "keyword": "ywlx",
            "name": "调离本市"
        },
        {
            "enumid": "0165",
            "code": "113",
            "keyword": "ywlx",
            "name": "单位退缴"
        },
        {
            "enumid": "0166",
            "code": "114",
            "keyword": "ywlx",
            "name": "单位资金调整"
        },
        {
            "enumid": "0138",
            "code": "115",
            "keyword": "ywlx",
            "name": "缴存人资金调整"
        },
        {
            "enumid": "0104",
            "code": "116",
            "keyword": "ywlx",
            "name": "缴存人资金转预缴户"
        },
        {
            "enumid": "0140",
            "code": "117",
            "keyword": "ywlx",
            "name": "结息"
        },
        {
            "enumid": "0105",
            "code": "118",
            "keyword": "ywlx",
            "name": "补缴"
        },
        {
            "enumid": "0108",
            "code": "119",
            "keyword": "ywlx",
            "name": "财政转预缴户"
        },
        {
            "enumid": "0109",
            "code": "120",
            "keyword": "ywlx",
            "name": "财政拨公积金"
        },
        {
            "enumid": "0210",
            "code": "121",
            "keyword": "ywlx",
            "name": "个人注销登记"
        },
        {
            "enumid": "0216",
            "code": "122",
            "keyword": "ywlx",
            "name": "特殊封存"
        },
        {
            "enumid": "0217",
            "code": "123",
            "keyword": "ywlx",
            "name": "解冻"
        },
        {
            "enumid": "0224",
            "code": "124",
            "keyword": "ywlx",
            "name": "新增异地贷款"
        },
        {
            "enumid": "0225",
            "code": "125",
            "keyword": "ywlx",
            "name": "解除异地贷款"
        },
        {
            "enumid": "0127",
            "code": "127",
            "keyword": "ywlx",
            "name": "退缴"
        },
        {
            "enumid": "0137",
            "code": "129",
            "keyword": "ywlx",
            "name": "同城销户转入"
        },
        {
            "enumid": "0136",
            "code": "130",
            "keyword": "ywlx",
            "name": "同城销户转出"
        },
        {
            "enumid": "0110",
            "code": "134",
            "keyword": "ywlx",
            "name": "托收缴存"
        },
        {
            "enumid": "0141",
            "code": "135",
            "keyword": "ywlx",
            "name": "托收补缴"
        },
        {
            "enumid": "0113",
            "code": "150",
            "keyword": "ywlx",
            "name": "批量提取"
        },
        {
            "enumid": "0161",
            "code": "183",
            "keyword": "ywlx",
            "name": "售房款缴存"
        },
        {
            "enumid": "0162",
            "code": "184",
            "keyword": "ywlx",
            "name": "售房款提取"
        },
        {
            "enumid": "0163",
            "code": "185",
            "keyword": "ywlx",
            "name": "售房款转移"
        },
        {
            "enumid": "0164",
            "code": "186",
            "keyword": "ywlx",
            "name": "售房款结息"
        },
        {
            "enumid": "0201",
            "code": "201",
            "keyword": "ywlx",
            "name": "单位开户"
        },
        {
            "enumid": "0202",
            "code": "202",
            "keyword": "ywlx",
            "name": "变更登记"
        },
        {
            "enumid": "0203",
            "code": "203",
            "keyword": "ywlx",
            "name": "单位注销登记"
        },
        {
            "enumid": "0204",
            "code": "204",
            "keyword": "ywlx",
            "name": "托收登记"
        },
        {
            "enumid": "0125",
            "code": "205",
            "keyword": "ywlx",
            "name": "免缴"
        },
        {
            "enumid": "0206",
            "code": "206",
            "keyword": "ywlx",
            "name": "缓缴"
        },
        {
            "enumid": "0207",
            "code": "207",
            "keyword": "ywlx",
            "name": "缴存比例调整"
        },
        {
            "enumid": "0208",
            "code": "208",
            "keyword": "ywlx",
            "name": "一般封存"
        },
        {
            "enumid": "0209",
            "code": "209",
            "keyword": "ywlx",
            "name": "缴存人账户设立"
        },
        {
            "enumid": "0221",
            "code": "210",
            "keyword": "ywlx",
            "name": "缴存核定"
        },
        {
            "enumid": "0211",
            "code": "211",
            "keyword": "ywlx",
            "name": "停缴"
        },
        {
            "enumid": "0228",
            "code": "212",
            "keyword": "ywlx",
            "name": "降低比例"
        },
        {
            "enumid": "0212",
            "code": "213",
            "keyword": "ywlx",
            "name": "调整基数"
        },
        {
            "enumid": "0213",
            "code": "214",
            "keyword": "ywlx",
            "name": "委托托收"
        },
        {
            "enumid": "0215",
            "code": "215",
            "keyword": "ywlx",
            "name": "新增黑名单"
        },
        {
            "enumid": "0139",
            "code": "216",
            "keyword": "ywlx",
            "name": "缴存人合户"
        },
        {
            "enumid": "0218",
            "code": "218",
            "keyword": "ywlx",
            "name": "单位信息变更"
        },
        {
            "enumid": "0219",
            "code": "219",
            "keyword": "ywlx",
            "name": "个人信息变更"
        },
        {
            "enumid": "0220",
            "code": "220",
            "keyword": "ywlx",
            "name": "单位年审"
        },
        {
            "enumid": "0229",
            "code": "221",
            "keyword": "ywlx",
            "name": "发卡"
        },
        {
            "enumid": "0230",
            "code": "222",
            "keyword": "ywlx",
            "name": "特殊比例变更申请"
        },
        {
            "enumid": "0231",
            "code": "223",
            "keyword": "ywlx",
            "name": "特殊汇缴变更申请"
        },
        {
            "enumid": "0222",
            "code": "224",
            "keyword": "ywlx",
            "name": "补缴申请审核受理"
        },
        {
            "enumid": "0205",
            "code": "225",
            "keyword": "ywlx",
            "name": "托收补缴登记"
        },
        {
            "enumid": "0226",
            "code": "226",
            "keyword": "ywlx",
            "name": "单位托收改签"
        },
        {
            "enumid": "0232",
            "code": "227",
            "keyword": "ywlx",
            "name": "单位默认缴存率变更"
        },
        {
            "enumid": "0256",
            "code": "228",
            "keyword": "ywlx",
            "name": "部门开户"
        },
        {
            "enumid": "0257",
            "code": "229",
            "keyword": "ywlx",
            "name": "部门信息变更"
        },
        {
            "enumid": "0258",
            "code": "230",
            "keyword": "ywlx",
            "name": "部门注销"
        },
        {
            "enumid": "0233",
            "code": "236",
            "keyword": "ywlx",
            "name": "缓缴恢复正常"
        },
        {
            "enumid": "0234",
            "code": "237",
            "keyword": "ywlx",
            "name": "停缴恢复正常"
        },
        {
            "enumid": "0235",
            "code": "238",
            "keyword": "ywlx",
            "name": "降低恢复正常"
        },
        {
            "enumid": "0236",
            "code": "239",
            "keyword": "ywlx",
            "name": "注销黑名单"
        },
        {
            "enumid": "0240",
            "code": "240",
            "keyword": "ywlx",
            "name": "缴存登记"
        },
        {
            "enumid": "0241",
            "code": "241",
            "keyword": "ywlx",
            "name": "解除免缴"
        },
        {
            "enumid": "0242",
            "code": "242",
            "keyword": "ywlx",
            "name": "柜面查询"
        },
        {
            "enumid": "0261",
            "code": "281",
            "keyword": "ywlx",
            "name": "售房单位开户"
        },
        {
            "enumid": "0262",
            "code": "282",
            "keyword": "ywlx",
            "name": "售房单位信息变更"
        },
        {
            "enumid": "0291",
            "code": "291",
            "keyword": "ywlx",
            "name": "单位托收签约"
        },
        {
            "enumid": "0293",
            "code": "293",
            "keyword": "ywlx",
            "name": "单位托收解约"
        },
        {
            "enumid": "0295",
            "code": "295",
            "keyword": "ywlx",
            "name": "个人托收签约"
        },
        {
            "enumid": "0296",
            "code": "296",
            "keyword": "ywlx",
            "name": "个人托收改约"
        },
        {
            "enumid": "0297",
            "code": "297",
            "keyword": "ywlx",
            "name": "个人托收解约"
        },
        {
            "enumid": "3001",
            "code": "301",
            "keyword": "ywlx",
            "name": "放款"
        },
        {
            "enumid": "3011",
            "code": "302",
            "keyword": "ywlx",
            "name": "还款"
        },
        {
            "enumid": "0557",
            "code": "557",
            "keyword": "ywlx",
            "name": "授信注销"
        },
        {
            "enumid": "0558",
            "code": "558",
            "keyword": "ywlx",
            "name": "按月支付利息"
        },
        {
            "enumid": "0559",
            "code": "559",
            "keyword": "ywlx",
            "name": "无主户资金拨付"
        },
        {
            "enumid": "0560",
            "code": "560",
            "keyword": "ywlx",
            "name": "无主户资金收入"
        },
        {
            "enumid": "0561",
            "code": "561",
            "keyword": "ywlx",
            "name": "考核受托银行"
        },
        {
            "enumid": "6003",
            "code": "601",
            "keyword": "ywlx",
            "name": "非业务类归档"
        },
        {
            "enumid": "6006",
            "code": "606",
            "keyword": "ywlx",
            "name": "补充个人档案"
        },
        {
            "enumid": "6007",
            "code": "607",
            "keyword": "ywlx",
            "name": "数据修改"
        },
        {
            "enumid": "6008",
            "code": "608",
            "keyword": "ywlx",
            "name": "非资金业务删除"
        },
        {
            "enumid": "6009",
            "code": "609",
            "keyword": "ywlx",
            "name": "资金业务删除"
        },
        {
            "enumid": "6010",
            "code": "610",
            "keyword": "ywlx",
            "name": "资金业务冲销"
        },
        {
            "enumid": "6005",
            "code": "701",
            "keyword": "ywlx",
            "name": "凭证建册"
        },
        {
            "enumid": "80",
            "code": "800",
            "keyword": "ywlx",
            "name": "执法"
        },
        {
            "enumid": "0801",
            "code": "801",
            "keyword": "ywlx",
            "name": "执法立案"
        },
        {
            "enumid": "8001",
            "code": "808",
            "keyword": "ywlx",
            "name": "催缴"
        },
        {
            "enumid": "90",
            "code": "901",
            "keyword": "ywlx",
            "name": "稽核"
        },
        {
            "enumid": "0920",
            "code": "920",
            "keyword": "ywlx",
            "name": "申请事项不予受理"
        },
        {
            "enumid": "1001",
            "code": "1001",
            "keyword": "ywlx",
            "name": "短信发送"
        },
        {
            "enumid": "0473",
            "code": "473",
            "keyword": "ywlx",
            "name": "住房公积金贷款协议冻结"
        },
        {
            "enumid": "0474",
            "code": "474",
            "keyword": "ywlx",
            "name": "住房公积金贷款协议解除冻结"
        },
        {
            "enumid": "0475",
            "code": "475",
            "keyword": "ywlx",
            "name": "住房公积金贷款协议注销"
        },
        {
            "enumid": "0469",
            "code": "469",
            "keyword": "ywlx",
            "name": "签订合同"
        },
        {
            "enumid": "3021",
            "code": "303",
            "keyword": "ywlx",
            "name": "结转逾期"
        },
        {
            "enumid": "3014",
            "code": "304",
            "keyword": "ywlx",
            "name": "归还逾期"
        },
        {
            "enumid": "3025",
            "code": "305",
            "keyword": "ywlx",
            "name": "坏账核销"
        },
        {
            "enumid": "0150",
            "code": "306",
            "keyword": "ywlx",
            "name": "公积金还贷自动扣划"
        },
        {
            "enumid": "3018",
            "code": "308",
            "keyword": "ywlx",
            "name": "提前还款冲账预付"
        },
        {
            "enumid": "3009",
            "code": "309",
            "keyword": "ywlx",
            "name": "贴息放款"
        },
        {
            "enumid": "3010",
            "code": "310",
            "keyword": "ywlx",
            "name": "贴息还款"
        },
        {
            "enumid": "3017",
            "code": "311",
            "keyword": "ywlx",
            "name": "放款失败"
        },
        {
            "enumid": "3003",
            "code": "316",
            "keyword": "ywlx",
            "name": "放贷划拨资金"
        },
        {
            "enumid": "3002",
            "code": "317",
            "keyword": "ywlx",
            "name": "放款确认"
        },
        {
            "enumid": "4005",
            "code": "318",
            "keyword": "ywlx",
            "name": "提前还款申请"
        },
        {
            "enumid": "3031",
            "code": "319",
            "keyword": "ywlx",
            "name": "贷款坏账核销"
        },
        {
            "enumid": "3200",
            "code": "320",
            "keyword": "ywlx",
            "name": "贷款发放冲账"
        },
        {
            "enumid": "4003",
            "code": "321",
            "keyword": "ywlx",
            "name": "一般还款制单"
        },
        {
            "enumid": "4004",
            "code": "322",
            "keyword": "ywlx",
            "name": "逾期还款制单"
        },
        {
            "enumid": "3012",
            "code": "323",
            "keyword": "ywlx",
            "name": "银行导入还款"
        },
        {
            "enumid": "3024",
            "code": "324",
            "keyword": "ywlx",
            "name": "贷款保证金抵押"
        },
        {
            "enumid": "3025",
            "code": "325",
            "keyword": "ywlx",
            "name": "贷款保证金解押"
        },
        {
            "enumid": "3026",
            "code": "326",
            "keyword": "ywlx",
            "name": "贷款保证金解押申请"
        },
        {
            "enumid": "3027",
            "code": "327",
            "keyword": "ywlx",
            "name": "贷款保证金转移"
        },
        {
            "enumid": "3028",
            "code": "328",
            "keyword": "ywlx",
            "name": "开发商保证金缴纳"
        },
        {
            "enumid": "3029",
            "code": "329",
            "keyword": "ywlx",
            "name": "开发商保证金解付"
        },
        {
            "enumid": "3030",
            "code": "330",
            "keyword": "ywlx",
            "name": "开发商保证金转移"
        },
        {
            "enumid": "4010",
            "code": "331",
            "keyword": "ywlx",
            "name": "年度贷款利率变更"
        },
        {
            "enumid": "4006",
            "code": "332",
            "keyword": "ywlx",
            "name": "贷款月末对账"
        },
        {
            "enumid": "4001",
            "code": "401",
            "keyword": "ywlx",
            "name": "贷款申请"
        },
        {
            "enumid": "4002",
            "code": "402",
            "keyword": "ywlx",
            "name": "贷款划拨"
        },
        {
            "enumid": "4030",
            "code": "403",
            "keyword": "ywlx",
            "name": "利率调整"
        },
        {
            "enumid": "4008",
            "code": "404",
            "keyword": "ywlx",
            "name": "贷款解除"
        },
        {
            "enumid": "4005",
            "code": "405",
            "keyword": "ywlx",
            "name": "提前还款贷款变更"
        },
        {
            "enumid": "4032",
            "code": "406",
            "keyword": "ywlx",
            "name": "银行托收制单"
        },
        {
            "enumid": "0227",
            "code": "407",
            "keyword": "ywlx",
            "name": "公积金还贷签约"
        },
        {
            "enumid": "4041",
            "code": "408",
            "keyword": "ywlx",
            "name": "贷款催还"
        },
        {
            "enumid": "4042",
            "code": "409",
            "keyword": "ywlx",
            "name": "处置申请"
        },
        {
            "enumid": "4043",
            "code": "410",
            "keyword": "ywlx",
            "name": "核销申请"
        },
        {
            "enumid": "4011",
            "code": "411",
            "keyword": "ywlx",
            "name": "新增楼盘"
        },
        {
            "enumid": "4012",
            "code": "412",
            "keyword": "ywlx",
            "name": "新增开发商"
        },
        {
            "enumid": "4013",
            "code": "413",
            "keyword": "ywlx",
            "name": "新增担保公司"
        },
        {
            "enumid": "4018",
            "code": "414",
            "keyword": "ywlx",
            "name": "借款人信息变更"
        },
        {
            "enumid": "4014",
            "code": "415",
            "keyword": "ywlx",
            "name": "合同信息变更"
        },
        {
            "enumid": "4019",
            "code": "416",
            "keyword": "ywlx",
            "name": "抵质押担保信息变更"
        },
        {
            "enumid": "4017",
            "code": "417",
            "keyword": "ywlx",
            "name": "贷款材料变更"
        },
        {
            "enumid": "4015",
            "code": "418",
            "keyword": "ywlx",
            "name": "共同申请人信息变更"
        },
        {
            "enumid": "4020",
            "code": "419",
            "keyword": "ywlx",
            "name": "房屋信息变更"
        },
        {
            "enumid": "3013",
            "code": "420",
            "keyword": "ywlx",
            "name": "托收还款确认"
        },
        {
            "enumid": "40021",
            "code": "421",
            "keyword": "ywlx",
            "name": "提前还款冲账"
        },
        {
            "enumid": "4021",
            "code": "422",
            "keyword": "ywlx",
            "name": "修改开发商"
        },
        {
            "enumid": "4022",
            "code": "423",
            "keyword": "ywlx",
            "name": "开发商销户"
        },
        {
            "enumid": "4023",
            "code": "424",
            "keyword": "ywlx",
            "name": "楼盘信息变更"
        },
        {
            "enumid": "40025",
            "code": "425",
            "keyword": "ywlx",
            "name": "还款账户信息变更"
        },
        {
            "enumid": "4024",
            "code": "426",
            "keyword": "ywlx",
            "name": "补录他项权证"
        },
        {
            "enumid": "0427",
            "code": "427",
            "keyword": "ywlx",
            "name": "项目调查核准登记"
        },
        {
            "enumid": "0428",
            "code": "428",
            "keyword": "ywlx",
            "name": "项目协议备案"
        },
        {
            "enumid": "0429",
            "code": "429",
            "keyword": "ywlx",
            "name": "项目协议变更"
        },
        {
            "enumid": "0430",
            "code": "430",
            "keyword": "ywlx",
            "name": "预售许可变更"
        },
        {
            "enumid": "4031",
            "code": "431",
            "keyword": "ywlx",
            "name": "抵押登记机构管理"
        },
        {
            "enumid": "4026",
            "code": "432",
            "keyword": "ywlx",
            "name": "抵押登记机构管理修改"
        },
        {
            "enumid": "4027",
            "code": "433",
            "keyword": "ywlx",
            "name": "抵押登记机构管理注销"
        },
        {
            "enumid": "4028",
            "code": "435",
            "keyword": "ywlx",
            "name": "抵押登记费支出申请"
        },
        {
            "enumid": "4036",
            "code": "436",
            "keyword": "ywlx",
            "name": "还款方式变更"
        },
        {
            "enumid": "4037",
            "code": "437",
            "keyword": "ywlx",
            "name": "贷款期限变更"
        },
        {
            "enumid": "4038",
            "code": "438",
            "keyword": "ywlx",
            "name": "还款日变更"
        },
        {
            "enumid": "4007",
            "code": "445",
            "keyword": "ywlx",
            "name": "登记逾期"
        },
        {
            "enumid": "0214",
            "code": "457",
            "keyword": "ywlx",
            "name": "生成委托提取单"
        },
        {
            "enumid": "4009",
            "code": "458",
            "keyword": "ywlx",
            "name": "贷款合同终止"
        },
        {
            "enumid": "0459",
            "code": "459",
            "keyword": "ywlx",
            "name": "公积金还贷改签"
        },
        {
            "enumid": "0460",
            "code": "460",
            "keyword": "ywlx",
            "name": "公积金还贷撤签"
        },
        {
            "enumid": "0461",
            "code": "461",
            "keyword": "ywlx",
            "name": "转移接续转入申请"
        },
        {
            "enumid": "0462",
            "code": "462",
            "keyword": "ywlx",
            "name": "转移接续转出"
        },
        {
            "enumid": "0466",
            "code": "466",
            "keyword": "ywlx",
            "name": "金融业务签订委托协议"
        },
        {
            "enumid": "0467",
            "code": "467",
            "keyword": "ywlx",
            "name": "金融业务签订委托协议注销"
        },
        {
            "enumid": "0468",
            "code": "468",
            "keyword": "ywlx",
            "name": "金融业务签订委托协议变更"
        },
        {
            "enumid": "0470",
            "code": "470",
            "keyword": "ywlx",
            "name": "客户服务/咨询"
        },
        {
            "enumid": "0471",
            "code": "471",
            "keyword": "ywlx",
            "name": "冲还贷-正常还款"
        },
        {
            "enumid": "0472",
            "code": "472",
            "keyword": "ywlx",
            "name": "冲还贷-归还逾期"
        },
        {
            "enumid": "0477",
            "code": "477",
            "keyword": "ywlx",
            "name": "抵押登记机构管理变更"
        },
        {
            "enumid": "0501",
            "code": "501",
            "keyword": "ywlx",
            "name": "推送出纳"
        },
        {
            "enumid": "0502",
            "code": "502",
            "keyword": "ywlx",
            "name": "制单"
        },
        {
            "enumid": "0503",
            "code": "503",
            "keyword": "ywlx",
            "name": "国债购买"
        },
        {
            "enumid": "0504",
            "code": "504",
            "keyword": "ywlx",
            "name": "国债兑付"
        },
        {
            "enumid": "0505",
            "code": "505",
            "keyword": "ywlx",
            "name": "定期存款"
        },
        {
            "enumid": "0506",
            "code": "506",
            "keyword": "ywlx",
            "name": "定期兑付"
        },
        {
            "enumid": "0507",
            "code": "507",
            "keyword": "ywlx",
            "name": "公积金利息预提"
        },
        {
            "enumid": "0508",
            "code": "508",
            "keyword": "ywlx",
            "name": "定期存款利息预提"
        },
        {
            "enumid": "0509",
            "code": "509",
            "keyword": "ywlx",
            "name": "国债利息预提"
        },
        {
            "enumid": "0510",
            "code": "510",
            "keyword": "ywlx",
            "name": "资金调拨"
        },
        {
            "enumid": "0511",
            "code": "511",
            "keyword": "ywlx",
            "name": "贷款手续费预提"
        },
        {
            "enumid": "0512",
            "code": "512",
            "keyword": "ywlx",
            "name": "归集手续费预提"
        },
        {
            "enumid": "0513",
            "code": "513",
            "keyword": "ywlx",
            "name": "保证金预提"
        },
        {
            "enumid": "0514",
            "code": "514",
            "keyword": "ywlx",
            "name": "活期利息收入"
        },
        {
            "enumid": "0515",
            "code": "516",
            "keyword": "ywlx",
            "name": "取消结账审批"
        },
        {
            "enumid": "0517",
            "code": "517",
            "keyword": "ywlx",
            "name": "资金计划"
        },
        {
            "enumid": "0518",
            "code": "518",
            "keyword": "ywlx",
            "name": "取消财务日结申请"
        },
        {
            "enumid": "0519",
            "code": "519",
            "keyword": "ywlx",
            "name": "缴费回退"
        },
        {
            "enumid": "0521",
            "code": "521",
            "keyword": "ywlx",
            "name": "手续费支出"
        },
        {
            "enumid": "0525",
            "code": "525",
            "keyword": "ywlx",
            "name": "单据入库"
        },
        {
            "enumid": "0526",
            "code": "526",
            "keyword": "ywlx",
            "name": "单据出库"
        },
        {
            "enumid": "0527",
            "code": "527",
            "keyword": "ywlx",
            "name": "资金调拨拨入"
        },
        {
            "enumid": "0528",
            "code": "528",
            "keyword": "ywlx",
            "name": "资金调拨拨出"
        },
        {
            "enumid": "0530",
            "code": "530",
            "keyword": "ywlx",
            "name": "通知存款存入"
        },
        {
            "enumid": "0531",
            "code": "531",
            "keyword": "ywlx",
            "name": "通知存款支取"
        },
        {
            "enumid": "0532",
            "code": "532",
            "keyword": "ywlx",
            "name": "结算费支出"
        },
        {
            "enumid": "0533",
            "code": "533",
            "keyword": "ywlx",
            "name": "支付管理费用"
        },
        {
            "enumid": "0534",
            "code": "534",
            "keyword": "ywlx",
            "name": "支付风险准备金"
        },
        {
            "enumid": "0535",
            "code": "535",
            "keyword": "ywlx",
            "name": "上缴财政专户"
        },
        {
            "enumid": "0536",
            "code": "536",
            "keyword": "ywlx",
            "name": "财政专户拨款"
        },
        {
            "enumid": "0556",
            "code": "556",
            "keyword": "ywlx",
            "name": "银行授信"
        }
    ],
    "ywly": [{
            "code": "801",
            "enumid": 901,
            "keyword": "business_source",
            "name": "临柜办理"
        },
        {
            "code": "902",
            "enumid": 902,
            "keyword": "business_source",
            "name": "网厅"
        },
        {
            "code": "903",
            "enumid": 903,
            "keyword": "business_source",
            "name": "待转移业务"
        },
        {
            "code": "904",
            "enumid": 904,
            "keyword": "business_source",
            "name": "期初导入"
        },
        {
            "code": "905",
            "enumid": 905,
            "keyword": "business_source",
            "name": "报盘导入"
        },
        {
            "code": "906",
            "enumid": 950,
            "keyword": "business_source",
            "name": "（门户）网站"
        },
        {
            "code": "907",
            "enumid": 951,
            "keyword": "business_source",
            "name": "自助终端"
        },
        {
            "code": "908",
            "enumid": 952,
            "keyword": "business_source",
            "name": "热线"
        },
        {
            "code": "909",
            "enumid": 953,
            "keyword": "business_source",
            "name": "短信"
        },
        {
            "code": "910",
            "enumid": 954,
            "keyword": "business_source",
            "name": "APP"
        },
        {
            "code": "911",
            "enumid": 955,
            "keyword": "business_source",
            "name": "微信"
        },
        {
            "code": "912",
            "enumid": 956,
            "keyword": "business_source",
            "name": "微博"
        }
    ],
    "ywmxlx": [{
            "code": "00",
            "enumid": 0,
            "keyword": "ywmxlx",
            "name": "期初"
        },
        {
            "code": "0101",
            "enumid": 101,
            "keyword": "ywmxlx",
            "name": "按月缴存"
        },
        {
            "code": "0102",
            "enumid": 102,
            "keyword": "ywmxlx",
            "name": "缴预缴户"
        },
        {
            "code": "0103",
            "enumid": 103,
            "keyword": "ywmxlx",
            "name": "预缴户转入"
        },
        {
            "code": "0104",
            "enumid": 116,
            "keyword": "ywmxlx",
            "name": "缴存人资金转预缴户"
        },
        {
            "code": "0105",
            "enumid": 118,
            "keyword": "ywmxlx",
            "name": "补缴"
        },
        {
            "code": "0106",
            "enumid": 104,
            "keyword": "ywmxlx",
            "name": "缴财政专户"
        },
        {
            "code": "0107",
            "enumid": 105,
            "keyword": "ywmxlx",
            "name": "财政专户资金调整"
        },
        {
            "code": "0108",
            "enumid": 119,
            "keyword": "ywmxlx",
            "name": "财政转预缴户"
        },
        {
            "code": "0109",
            "enumid": 120,
            "keyword": "ywmxlx",
            "name": "财政拨公积金"
        },
        {
            "code": "0110",
            "enumid": 134,
            "keyword": "ywmxlx",
            "name": "托收缴存"
        },
        {
            "code": "0111",
            "enumid": 107,
            "keyword": "ywmxlx",
            "name": "提取"
        },
        {
            "code": "0112",
            "enumid": 106,
            "keyword": "ywmxlx",
            "name": "部分提取"
        },
        {
            "code": "0113",
            "enumid": 150,
            "keyword": "ywmxlx",
            "name": "批量提取"
        },
        {
            "code": "0125",
            "enumid": 205,
            "keyword": "ywmxlx",
            "name": "免缴"
        },
        {
            "code": "0127",
            "enumid": 127,
            "keyword": "ywmxlx",
            "name": "退缴"
        },
        {
            "code": "0131",
            "enumid": 108,
            "keyword": "ywmxlx",
            "name": "内部转移"
        },
        {
            "code": "0132",
            "enumid": 110,
            "keyword": "ywmxlx",
            "name": "外部转出"
        },
        {
            "code": "0133",
            "enumid": 109,
            "keyword": "ywmxlx",
            "name": "外部转入"
        },
        {
            "code": "0134",
            "enumid": 112,
            "keyword": "ywmxlx",
            "name": "调离本市"
        },
        {
            "code": "0135",
            "enumid": 111,
            "keyword": "ywmxlx",
            "name": "异地调入"
        },
        {
            "code": "0136",
            "enumid": 130,
            "keyword": "ywmxlx",
            "name": "同城销户转出"
        },
        {
            "code": "0137",
            "enumid": 129,
            "keyword": "ywmxlx",
            "name": "同城销户转入"
        },
        {
            "code": "0138",
            "enumid": 115,
            "keyword": "ywmxlx",
            "name": "缴存人资金调整"
        },
        {
            "code": "0139",
            "enumid": 216,
            "keyword": "ywmxlx",
            "name": "缴存人合户"
        },
        {
            "code": "0140",
            "enumid": 117,
            "keyword": "ywmxlx",
            "name": "结息"
        },
        {
            "code": "0141",
            "enumid": 135,
            "keyword": "ywmxlx",
            "name": "托收补缴"
        },
        {
            "code": "0150",
            "enumid": 306,
            "keyword": "ywmxlx",
            "name": "公积金还贷自动扣划"
        },
        {
            "code": "0161",
            "enumid": 183,
            "keyword": "ywmxlx",
            "name": "售房款缴存"
        },
        {
            "code": "0162",
            "enumid": 184,
            "keyword": "ywmxlx",
            "name": "售房款提取"
        },
        {
            "code": "0163",
            "enumid": 185,
            "keyword": "ywmxlx",
            "name": "售房款转移"
        },
        {
            "code": "0164",
            "enumid": 186,
            "keyword": "ywmxlx",
            "name": "售房款结息"
        },
        {
            "code": "0165",
            "enumid": 113,
            "keyword": "ywmxlx",
            "name": "单位退缴"
        },
        {
            "code": "0166",
            "enumid": 114,
            "keyword": "ywmxlx",
            "name": "单位资金调整"
        },
        {
            "code": "0201",
            "enumid": 201,
            "keyword": "ywmxlx",
            "name": "单位开户"
        },
        {
            "code": "0202",
            "enumid": 202,
            "keyword": "ywmxlx",
            "name": "变更登记"
        },
        {
            "code": "0203",
            "enumid": 203,
            "keyword": "ywmxlx",
            "name": "单位注销登记"
        },
        {
            "code": "0204",
            "enumid": 204,
            "keyword": "ywmxlx",
            "name": "托收登记"
        },
        {
            "code": "0205",
            "enumid": 225,
            "keyword": "ywmxlx",
            "name": "托收补缴登记"
        },
        {
            "code": "0206",
            "enumid": 206,
            "keyword": "ywmxlx",
            "name": "缓缴"
        },
        {
            "code": "0207",
            "enumid": 207,
            "keyword": "ywmxlx",
            "name": "缴存比例调整"
        },
        {
            "code": "0208",
            "enumid": 208,
            "keyword": "ywmxlx",
            "name": "一般封存"
        },
        {
            "code": "0209",
            "enumid": 209,
            "keyword": "ywmxlx",
            "name": "缴存人账户设立"
        },
        {
            "code": "0210",
            "enumid": 121,
            "keyword": "ywmxlx",
            "name": "个人注销登记"
        },
        {
            "code": "0211",
            "enumid": 211,
            "keyword": "ywmxlx",
            "name": "停缴"
        },
        {
            "code": "0212",
            "enumid": 213,
            "keyword": "ywmxlx",
            "name": "调整基数"
        },
        {
            "code": "0213",
            "enumid": 214,
            "keyword": "ywmxlx",
            "name": "委托托收"
        },
        {
            "code": "0214",
            "enumid": 457,
            "keyword": "ywmxlx",
            "name": "生成委托提取单"
        },
        {
            "code": "0215",
            "enumid": 215,
            "keyword": "ywmxlx",
            "name": "新增黑名单"
        },
        {
            "code": "0216",
            "enumid": 122,
            "keyword": "ywmxlx",
            "name": "特殊封存"
        },
        {
            "code": "0217",
            "enumid": 123,
            "keyword": "ywmxlx",
            "name": "解冻"
        },
        {
            "code": "0218",
            "enumid": 218,
            "keyword": "ywmxlx",
            "name": "单位信息变更"
        },
        {
            "code": "0219",
            "enumid": 219,
            "keyword": "ywmxlx",
            "name": "个人信息变更"
        },
        {
            "code": "0220",
            "enumid": 220,
            "keyword": "ywmxlx",
            "name": "单位年审"
        },
        {
            "code": "0221",
            "enumid": 210,
            "keyword": "ywmxlx",
            "name": "缴存核定"
        },
        {
            "code": "0222",
            "enumid": 224,
            "keyword": "ywmxlx",
            "name": "补缴申请审核受理"
        },
        {
            "code": "0224",
            "enumid": 124,
            "keyword": "ywmxlx",
            "name": "新增异地贷款"
        },
        {
            "code": "0225",
            "enumid": 125,
            "keyword": "ywmxlx",
            "name": "解除异地贷款"
        },
        {
            "code": "0226",
            "enumid": 226,
            "keyword": "ywmxlx",
            "name": "单位托收改签"
        },
        {
            "code": "0227",
            "enumid": 407,
            "keyword": "ywmxlx",
            "name": "公积金还贷签约"
        },
        {
            "code": "0228",
            "enumid": 212,
            "keyword": "ywmxlx",
            "name": "降低比例"
        },
        {
            "code": "0229",
            "enumid": 221,
            "keyword": "ywmxlx",
            "name": "发卡"
        },
        {
            "code": "0230",
            "enumid": 222,
            "keyword": "ywmxlx",
            "name": "特殊比例变更申请"
        },
        {
            "code": "0231",
            "enumid": 223,
            "keyword": "ywmxlx",
            "name": "特殊汇缴变更申请"
        },
        {
            "code": "0232",
            "enumid": 227,
            "keyword": "ywmxlx",
            "name": "单位默认缴存率变更"
        },
        {
            "code": "0233",
            "enumid": 236,
            "keyword": "ywmxlx",
            "name": "缓缴恢复正常"
        },
        {
            "code": "0234",
            "enumid": 237,
            "keyword": "ywmxlx",
            "name": "停缴恢复正常"
        },
        {
            "code": "0235",
            "enumid": 238,
            "keyword": "ywmxlx",
            "name": "降低恢复正常"
        },
        {
            "code": "0236",
            "enumid": 239,
            "keyword": "ywmxlx",
            "name": "注销黑名单"
        },
        {
            "code": "0240",
            "enumid": 240,
            "keyword": "ywmxlx",
            "name": "缴存登记"
        },
        {
            "code": "0241",
            "enumid": 241,
            "keyword": "ywmxlx",
            "name": "解除免缴"
        },
        {
            "code": "0242",
            "enumid": 242,
            "keyword": "ywmxlx",
            "name": "柜面查询"
        },
        {
            "code": "0256",
            "enumid": 228,
            "keyword": "ywmxlx",
            "name": "部门开户"
        },
        {
            "code": "0257",
            "enumid": 229,
            "keyword": "ywmxlx",
            "name": "部门信息变更"
        },
        {
            "code": "0258",
            "enumid": 230,
            "keyword": "ywmxlx",
            "name": "部门注销"
        },
        {
            "code": "0261",
            "enumid": 281,
            "keyword": "ywmxlx",
            "name": "售房单位开户"
        },
        {
            "code": "0262",
            "enumid": 282,
            "keyword": "ywmxlx",
            "name": "售房单位信息变更"
        },
        {
            "code": "0291",
            "enumid": 291,
            "keyword": "ywmxlx",
            "name": "单位托收签约"
        },
        {
            "code": "0293",
            "enumid": 293,
            "keyword": "ywmxlx",
            "name": "单位托收解约"
        },
        {
            "code": "0295",
            "enumid": 295,
            "keyword": "ywmxlx",
            "name": "个人托收签约"
        },
        {
            "code": "0296",
            "enumid": 296,
            "keyword": "ywmxlx",
            "name": "个人托收改约"
        },
        {
            "code": "0297",
            "enumid": 297,
            "keyword": "ywmxlx",
            "name": "个人托收解约"
        },
        {
            "code": "0427",
            "enumid": 427,
            "keyword": "ywmxlx",
            "name": "项目调查核准登记"
        },
        {
            "code": "0428",
            "enumid": 428,
            "keyword": "ywmxlx",
            "name": "项目协议备案"
        },
        {
            "code": "0429",
            "enumid": 429,
            "keyword": "ywmxlx",
            "name": "项目协议变更"
        },
        {
            "code": "0430",
            "enumid": 430,
            "keyword": "ywmxlx",
            "name": "预售许可变更"
        },
        {
            "code": "0459",
            "enumid": 459,
            "keyword": "ywmxlx",
            "name": "公积金还贷改签"
        },
        {
            "code": "0460",
            "enumid": 460,
            "keyword": "ywmxlx",
            "name": "公积金还贷撤签"
        },
        {
            "code": "0461",
            "enumid": 461,
            "keyword": "ywmxlx",
            "name": "转移接续转入申请"
        },
        {
            "code": "0462",
            "enumid": 462,
            "keyword": "ywmxlx",
            "name": "转移接续转出"
        },
        {
            "code": "0466",
            "enumid": 466,
            "keyword": "ywmxlx",
            "name": "金融业务签订委托协议"
        },
        {
            "code": "0467",
            "enumid": 467,
            "keyword": "ywmxlx",
            "name": "金融业务签订委托协议注销"
        },
        {
            "code": "0468",
            "enumid": 468,
            "keyword": "ywmxlx",
            "name": "金融业务签订委托协议变更"
        },
        {
            "code": "0469",
            "enumid": 469,
            "keyword": "ywmxlx",
            "name": "签订合同"
        },
        {
            "code": "0470",
            "enumid": 470,
            "keyword": "ywmxlx",
            "name": "客户服务/咨询"
        },
        {
            "code": "0471",
            "enumid": 471,
            "keyword": "ywmxlx",
            "name": "冲还贷-正常还款"
        },
        {
            "code": "0472",
            "enumid": 472,
            "keyword": "ywmxlx",
            "name": "冲还贷-归还逾期"
        },
        {
            "code": "0473",
            "enumid": 473,
            "keyword": "ywmxlx",
            "name": "住房公积金贷款协议冻结"
        },
        {
            "code": "0474",
            "enumid": 474,
            "keyword": "ywmxlx",
            "name": "住房公积金贷款协议解除冻结"
        },
        {
            "code": "0475",
            "enumid": 475,
            "keyword": "ywmxlx",
            "name": "住房公积金贷款协议注销"
        },
        {
            "code": "0477",
            "enumid": 477,
            "keyword": "ywmxlx",
            "name": "抵押登记机构管理变更"
        },
        {
            "code": "0501",
            "enumid": 501,
            "keyword": "ywmxlx",
            "name": "推送出纳"
        },
        {
            "code": "0502",
            "enumid": 502,
            "keyword": "ywmxlx",
            "name": "制单"
        },
        {
            "code": "0503",
            "enumid": 503,
            "keyword": "ywmxlx",
            "name": "国债购买"
        },
        {
            "code": "0504",
            "enumid": 504,
            "keyword": "ywmxlx",
            "name": "国债兑付"
        },
        {
            "code": "0505",
            "enumid": 505,
            "keyword": "ywmxlx",
            "name": "定期存款"
        },
        {
            "code": "0506",
            "enumid": 506,
            "keyword": "ywmxlx",
            "name": "定期兑付"
        },
        {
            "code": "0507",
            "enumid": 507,
            "keyword": "ywmxlx",
            "name": "公积金利息预提"
        },
        {
            "code": "0508",
            "enumid": 508,
            "keyword": "ywmxlx",
            "name": "定期存款利息预提"
        },
        {
            "code": "0509",
            "enumid": 509,
            "keyword": "ywmxlx",
            "name": "国债利息预提"
        },
        {
            "code": "0510",
            "enumid": 510,
            "keyword": "ywmxlx",
            "name": "资金调拨"
        },
        {
            "code": "0511",
            "enumid": 511,
            "keyword": "ywmxlx",
            "name": "贷款手续费预提"
        },
        {
            "code": "0512",
            "enumid": 512,
            "keyword": "ywmxlx",
            "name": "归集手续费预提"
        },
        {
            "code": "0513",
            "enumid": 513,
            "keyword": "ywmxlx",
            "name": "保证金预提"
        },
        {
            "code": "0514",
            "enumid": 514,
            "keyword": "ywmxlx",
            "name": "活期利息收入"
        },
        {
            "code": "0515",
            "enumid": 516,
            "keyword": "ywmxlx",
            "name": "取消结账审批"
        },
        {
            "code": "0517",
            "enumid": 517,
            "keyword": "ywmxlx",
            "name": "资金计划"
        },
        {
            "code": "0518",
            "enumid": 518,
            "keyword": "ywmxlx",
            "name": "取消财务日结申请"
        },
        {
            "code": "0519",
            "enumid": 519,
            "keyword": "ywmxlx",
            "name": "缴费回退"
        },
        {
            "code": "0521",
            "enumid": 521,
            "keyword": "ywmxlx",
            "name": "手续费支出"
        },
        {
            "code": "0525",
            "enumid": 525,
            "keyword": "ywmxlx",
            "name": "单据入库"
        },
        {
            "code": "0526",
            "enumid": 526,
            "keyword": "ywmxlx",
            "name": "单据出库"
        },
        {
            "code": "0527",
            "enumid": 527,
            "keyword": "ywmxlx",
            "name": "资金调拨拨入"
        },
        {
            "code": "0528",
            "enumid": 528,
            "keyword": "ywmxlx",
            "name": "资金调拨拨出"
        },
        {
            "code": "0530",
            "enumid": 530,
            "keyword": "ywmxlx",
            "name": "通知存款存入"
        },
        {
            "code": "0531",
            "enumid": 531,
            "keyword": "ywmxlx",
            "name": "通知存款支取"
        },
        {
            "code": "0532",
            "enumid": 532,
            "keyword": "ywmxlx",
            "name": "结算费支出"
        },
        {
            "code": "0533",
            "enumid": 533,
            "keyword": "ywmxlx",
            "name": "支付管理费用"
        },
        {
            "code": "0534",
            "enumid": 534,
            "keyword": "ywmxlx",
            "name": "支付风险准备金"
        },
        {
            "code": "0535",
            "enumid": 535,
            "keyword": "ywmxlx",
            "name": "上缴财政专户"
        },
        {
            "code": "0536",
            "enumid": 536,
            "keyword": "ywmxlx",
            "name": "财政专户拨款"
        },
        {
            "code": "0556",
            "enumid": 556,
            "keyword": "ywmxlx",
            "name": "银行授信"
        },
        {
            "code": "0557",
            "enumid": 557,
            "keyword": "ywmxlx",
            "name": "授信注销"
        },
        {
            "code": "0558",
            "enumid": 558,
            "keyword": "ywmxlx",
            "name": "按月支付利息"
        },
        {
            "code": "0559",
            "enumid": 559,
            "keyword": "ywmxlx",
            "name": "无主户资金拨付"
        },
        {
            "code": "0560",
            "enumid": 560,
            "keyword": "ywmxlx",
            "name": "无主户资金收入"
        },
        {
            "code": "0561",
            "enumid": 561,
            "keyword": "ywmxlx",
            "name": "考核受托银行"
        },
        {
            "code": "0801",
            "enumid": 801,
            "keyword": "ywmxlx",
            "name": "执法立案"
        },
        {
            "code": "0920",
            "enumid": 920,
            "keyword": "ywmxlx",
            "name": "申请事项不予受理"
        },
        {
            "code": "1001",
            "enumid": 1001,
            "keyword": "ywmxlx",
            "name": "短信发送"
        },
        {
            "code": "3001",
            "enumid": 301,
            "keyword": "ywmxlx",
            "name": "放款"
        },
        {
            "code": "3002",
            "enumid": 317,
            "keyword": "ywmxlx",
            "name": "放款确认"
        },
        {
            "code": "3003",
            "enumid": 316,
            "keyword": "ywmxlx",
            "name": "放贷划拨资金"
        },
        {
            "code": "3009",
            "enumid": 309,
            "keyword": "ywmxlx",
            "name": "贴息放款"
        },
        {
            "code": "3010",
            "enumid": 310,
            "keyword": "ywmxlx",
            "name": "贴息还款"
        },
        {
            "code": "3011",
            "enumid": 302,
            "keyword": "ywmxlx",
            "name": "还款"
        },
        {
            "code": "3012",
            "enumid": 323,
            "keyword": "ywmxlx",
            "name": "银行导入还款"
        },
        {
            "code": "3013",
            "enumid": 420,
            "keyword": "ywmxlx",
            "name": "托收还款确认"
        },
        {
            "code": "3014",
            "enumid": 304,
            "keyword": "ywmxlx",
            "name": "归还逾期"
        },
        {
            "code": "3017",
            "enumid": 311,
            "keyword": "ywmxlx",
            "name": "放款失败"
        },
        {
            "code": "3018",
            "enumid": 308,
            "keyword": "ywmxlx",
            "name": "提前还款冲账预付"
        },
        {
            "code": "3021",
            "enumid": 303,
            "keyword": "ywmxlx",
            "name": "结转逾期"
        },
        {
            "code": "3024",
            "enumid": 324,
            "keyword": "ywmxlx",
            "name": "贷款保证金抵押"
        },
        {
            "code": "3025",
            "enumid": 305,
            "keyword": "ywmxlx",
            "name": "坏账核销"
        },
        {
            "code": "3025",
            "enumid": 325,
            "keyword": "ywmxlx",
            "name": "贷款保证金解押"
        },
        {
            "code": "3026",
            "enumid": 326,
            "keyword": "ywmxlx",
            "name": "贷款保证金解押申请"
        },
        {
            "code": "3027",
            "enumid": 327,
            "keyword": "ywmxlx",
            "name": "贷款保证金转移"
        },
        {
            "code": "3028",
            "enumid": 328,
            "keyword": "ywmxlx",
            "name": "开发商保证金缴纳"
        },
        {
            "code": "3029",
            "enumid": 329,
            "keyword": "ywmxlx",
            "name": "开发商保证金解付"
        },
        {
            "code": "3030",
            "enumid": 330,
            "keyword": "ywmxlx",
            "name": "开发商保证金转移"
        },
        {
            "code": "3031",
            "enumid": 319,
            "keyword": "ywmxlx",
            "name": "贷款坏账核销"
        },
        {
            "code": "3200",
            "enumid": 320,
            "keyword": "ywmxlx",
            "name": "贷款发放冲账"
        },
        {
            "code": "4001",
            "enumid": 401,
            "keyword": "ywmxlx",
            "name": "贷款申请"
        },
        {
            "code": "4002",
            "enumid": 402,
            "keyword": "ywmxlx",
            "name": "贷款划拨"
        },
        {
            "code": "40021",
            "enumid": 421,
            "keyword": "ywmxlx",
            "name": "提前还款冲账"
        },
        {
            "code": "40025",
            "enumid": 425,
            "keyword": "ywmxlx",
            "name": "还款账户信息变更"
        },
        {
            "code": "4003",
            "enumid": 321,
            "keyword": "ywmxlx",
            "name": "一般还款制单"
        },
        {
            "code": "4004",
            "enumid": 322,
            "keyword": "ywmxlx",
            "name": "逾期还款制单"
        },
        {
            "code": "4005",
            "enumid": 318,
            "keyword": "ywmxlx",
            "name": "提前还款申请"
        },
        {
            "code": "4005",
            "enumid": 405,
            "keyword": "ywmxlx",
            "name": "提前还款贷款变更"
        },
        {
            "code": "4006",
            "enumid": 332,
            "keyword": "ywmxlx",
            "name": "贷款月末对账"
        },
        {
            "code": "4007",
            "enumid": 445,
            "keyword": "ywmxlx",
            "name": "登记逾期"
        },
        {
            "code": "4008",
            "enumid": 404,
            "keyword": "ywmxlx",
            "name": "贷款解除"
        },
        {
            "code": "4009",
            "enumid": 458,
            "keyword": "ywmxlx",
            "name": "贷款合同终止"
        },
        {
            "code": "4010",
            "enumid": 331,
            "keyword": "ywmxlx",
            "name": "年度贷款利率变更"
        },
        {
            "code": "4011",
            "enumid": 411,
            "keyword": "ywmxlx",
            "name": "新增楼盘"
        },
        {
            "code": "4012",
            "enumid": 412,
            "keyword": "ywmxlx",
            "name": "新增开发商"
        },
        {
            "code": "4013",
            "enumid": 413,
            "keyword": "ywmxlx",
            "name": "新增担保公司"
        },
        {
            "code": "4014",
            "enumid": 415,
            "keyword": "ywmxlx",
            "name": "合同信息变更"
        },
        {
            "code": "4015",
            "enumid": 418,
            "keyword": "ywmxlx",
            "name": "共同申请人信息变更"
        },
        {
            "code": "4017",
            "enumid": 417,
            "keyword": "ywmxlx",
            "name": "贷款材料变更"
        },
        {
            "code": "4018",
            "enumid": 414,
            "keyword": "ywmxlx",
            "name": "借款人信息变更"
        },
        {
            "code": "4019",
            "enumid": 416,
            "keyword": "ywmxlx",
            "name": "抵质押担保信息变更"
        },
        {
            "code": "4020",
            "enumid": 419,
            "keyword": "ywmxlx",
            "name": "房屋信息变更"
        },
        {
            "code": "4021",
            "enumid": 422,
            "keyword": "ywmxlx",
            "name": "修改开发商"
        },
        {
            "code": "4022",
            "enumid": 423,
            "keyword": "ywmxlx",
            "name": "开发商销户"
        },
        {
            "code": "4023",
            "enumid": 424,
            "keyword": "ywmxlx",
            "name": "楼盘信息变更"
        },
        {
            "code": "4024",
            "enumid": 426,
            "keyword": "ywmxlx",
            "name": "补录他项权证"
        },
        {
            "code": "4026",
            "enumid": 432,
            "keyword": "ywmxlx",
            "name": "抵押登记机构管理修改"
        },
        {
            "code": "4027",
            "enumid": 433,
            "keyword": "ywmxlx",
            "name": "抵押登记机构管理注销"
        },
        {
            "code": "4028",
            "enumid": 435,
            "keyword": "ywmxlx",
            "name": "抵押登记费支出申请"
        },
        {
            "code": "4030",
            "enumid": 403,
            "keyword": "ywmxlx",
            "name": "利率调整"
        },
        {
            "code": "4031",
            "enumid": 431,
            "keyword": "ywmxlx",
            "name": "抵押登记机构管理"
        },
        {
            "code": "4032",
            "enumid": 406,
            "keyword": "ywmxlx",
            "name": "银行托收制单"
        },
        {
            "code": "4036",
            "enumid": 436,
            "keyword": "ywmxlx",
            "name": "还款方式变更"
        },
        {
            "code": "4037",
            "enumid": 437,
            "keyword": "ywmxlx",
            "name": "贷款期限变更"
        },
        {
            "code": "4038",
            "enumid": 438,
            "keyword": "ywmxlx",
            "name": "还款日变更"
        },
        {
            "code": "4041",
            "enumid": 408,
            "keyword": "ywmxlx",
            "name": "贷款催还"
        },
        {
            "code": "4042",
            "enumid": 409,
            "keyword": "ywmxlx",
            "name": "处置申请"
        },
        {
            "code": "4043",
            "enumid": 410,
            "keyword": "ywmxlx",
            "name": "核销申请"
        },
        {
            "code": "6003",
            "enumid": 601,
            "keyword": "ywmxlx",
            "name": "非业务类归档"
        },
        {
            "code": "6005",
            "enumid": 701,
            "keyword": "ywmxlx",
            "name": "凭证建册"
        },
        {
            "code": "6006",
            "enumid": 606,
            "keyword": "ywmxlx",
            "name": "补充个人档案"
        },
        {
            "code": "6007",
            "enumid": 607,
            "keyword": "ywmxlx",
            "name": "数据修改"
        },
        {
            "code": "6008",
            "enumid": 608,
            "keyword": "ywmxlx",
            "name": "非资金业务删除"
        },
        {
            "code": "6009",
            "enumid": 609,
            "keyword": "ywmxlx",
            "name": "资金业务删除"
        },
        {
            "code": "6010",
            "enumid": 610,
            "keyword": "ywmxlx",
            "name": "资金业务冲销"
        },
        {
            "code": "80",
            "enumid": 800,
            "keyword": "ywmxlx",
            "name": "执法"
        },
        {
            "code": "8001",
            "enumid": 808,
            "keyword": "ywmxlx",
            "name": "催缴"
        },
        {
            "code": "90",
            "enumid": 901,
            "keyword": "ywmxlx",
            "name": "稽核"
        }
    ],
    "ywzt": [{
            "code": "1",
            "enumid": 1,
            "keyword": "ywzt",
            "name": "暂存"
        },
        {
            "code": "2",
            "enumid": 2,
            "keyword": "ywzt",
            "name": "待处理"
        },
        {
            "code": "3",
            "enumid": 3,
            "keyword": "ywzt",
            "name": "已处理"
        },
        {
            "code": "4",
            "enumid": 4,
            "keyword": "ywzt",
            "name": "已办结"
        },
        {
            "code": "5",
            "enumid": 5,
            "keyword": "ywzt",
            "name": "已中止"
        },
        {
            "code": "6",
            "enumid": 6,
            "keyword": "ywzt",
            "name": "已回退"
        },
        {
            "code": "7",
            "enumid": 7,
            "keyword": "ywzt",
            "name": "作废"
        }
    ],
    "zhichen": [{
            "code": "001",
            "enumid": 410052,
            "keyword": "loanapply_title",
            "name": "初级职称"
        },
        {
            "code": "002",
            "enumid": 410053,
            "keyword": "loanapply_title",
            "name": "中级职称"
        },
        {
            "code": "003",
            "enumid": 410054,
            "keyword": "loanapply_title",
            "name": "高级职称"
        },
        {
            "code": "004",
            "enumid": 410055,
            "keyword": "loanapply_title",
            "name": "公务员"
        },
        {
            "code": "990",
            "enumid": 410057,
            "keyword": "loanapply_title",
            "name": "自由职业者"
        },
        {
            "code": "010",
            "enumid": 410058,
            "keyword": "loanapply_title",
            "name": "高等学校教师"
        },
        {
            "code": "020",
            "enumid": 410059,
            "keyword": "loanapply_title",
            "name": "中等专业学校教师"
        },
        {
            "code": "030",
            "enumid": 410060,
            "keyword": "loanapply_title",
            "name": "技工学校教师"
        },
        {
            "code": "050",
            "enumid": 410062,
            "keyword": "loanapply_title",
            "name": "中学教师"
        },
        {
            "code": "080",
            "enumid": 410064,
            "keyword": "loanapply_title",
            "name": "工程技术人员"
        },
        {
            "code": "090",
            "enumid": 410065,
            "keyword": "loanapply_title",
            "name": "农业技术人员(农艺)"
        },
        {
            "code": "120",
            "enumid": 410068,
            "keyword": "loanapply_title",
            "name": "经济专业人员"
        },
        {
            "code": "130",
            "enumid": 410069,
            "keyword": "loanapply_title",
            "name": "会计专业人员"
        },
        {
            "code": "220",
            "enumid": 410077,
            "keyword": "loanapply_title",
            "name": "播音员"
        },
        {
            "code": "230",
            "enumid": 410078,
            "keyword": "loanapply_title",
            "name": "卫生技术人员(医师)"
        },
        {
            "code": "250",
            "enumid": 410080,
            "keyword": "loanapply_title",
            "name": "卫生技术人员(护理)"
        },
        {
            "code": "260",
            "enumid": 410081,
            "keyword": "loanapply_title",
            "name": "卫生技术人员(技师)"
        },
        {
            "code": "280",
            "enumid": 410083,
            "keyword": "loanapply_title",
            "name": "艺术人员(演员)"
        },
        {
            "code": "370",
            "enumid": 410092,
            "keyword": "loanapply_title",
            "name": "体育教练"
        },
        {
            "code": "390",
            "enumid": 410093,
            "keyword": "loanapply_title",
            "name": "律师"
        },
        {
            "code": "400",
            "enumid": 410094,
            "keyword": "loanapply_title",
            "name": "公证员"
        },
        {
            "code": "410",
            "enumid": 410095,
            "keyword": "loanapply_title",
            "name": "小学教师"
        },
        {
            "code": "610",
            "enumid": 410105,
            "keyword": "loanapply_title",
            "name": "自然科学研究人员"
        },
        {
            "code": "620",
            "enumid": 410106,
            "keyword": "loanapply_title",
            "name": "社会科学研究人员"
        },
        {
            "code": "640",
            "enumid": 410107,
            "keyword": "loanapply_title",
            "name": "图书、资料专业人员"
        },
        {
            "code": "670",
            "enumid": 410110,
            "keyword": "loanapply_title",
            "name": "群众文化专业人员"
        },
        {
            "code": "680",
            "enumid": 410111,
            "keyword": "loanapply_title",
            "name": "审计专业人员"
        }
    ],
    "zhiwu": [{
            "code": "0001",
            "enumid": 69,
            "keyword": "loanapply_position",
            "name": "职员"
        },
        {
            "code": "0002",
            "enumid": 70,
            "keyword": "loanapply_position",
            "name": "科级"
        },
        {
            "code": "0003",
            "enumid": 71,
            "keyword": "loanapply_position",
            "name": "处级及以上"
        },
        {
            "code": "001A",
            "enumid": 1302,
            "keyword": "loanapply_position",
            "name": "书记"
        },
        {
            "code": "002A",
            "enumid": 1308,
            "keyword": "loanapply_position",
            "name": "委员"
        },
        {
            "code": "004A",
            "enumid": 1313,
            "keyword": "loanapply_position",
            "name": "主任"
        },
        {
            "code": "004B",
            "enumid": 1314,
            "keyword": "loanapply_position",
            "name": "副主任"
        },
        {
            "code": "211A",
            "enumid": 1345,
            "keyword": "loanapply_position",
            "name": "部长"
        },
        {
            "code": "216A",
            "enumid": 1354,
            "keyword": "loanapply_position",
            "name": "局长"
        },
        {
            "code": "217A",
            "enumid": 1356,
            "keyword": "loanapply_position",
            "name": "厅长"
        },
        {
            "code": "219A",
            "enumid": 1360,
            "keyword": "loanapply_position",
            "name": "处长"
        },
        {
            "code": "220A",
            "enumid": 1362,
            "keyword": "loanapply_position",
            "name": "科长"
        },
        {
            "code": "221A",
            "enumid": 1366,
            "keyword": "loanapply_position",
            "name": "科员"
        },
        {
            "code": "222A",
            "enumid": 1367,
            "keyword": "loanapply_position",
            "name": "股长"
        },
        {
            "code": "224A",
            "enumid": 1369,
            "keyword": "loanapply_position",
            "name": "办事员"
        },
        {
            "code": "258A",
            "enumid": 1382,
            "keyword": "loanapply_position",
            "name": "县长"
        },
        {
            "code": "260A",
            "enumid": 1386,
            "keyword": "loanapply_position",
            "name": "镇长"
        },
        {
            "code": "261A",
            "enumid": 1388,
            "keyword": "loanapply_position",
            "name": "乡长"
        },
        {
            "code": "402A",
            "enumid": 1417,
            "keyword": "loanapply_position",
            "name": "行长"
        },
        {
            "code": "434Q",
            "enumid": 1459,
            "keyword": "loanapply_position",
            "name": "总经理"
        },
        {
            "code": "434R",
            "enumid": 1460,
            "keyword": "loanapply_position",
            "name": "副总经理"
        },
        {
            "code": "436A",
            "enumid": 1461,
            "keyword": "loanapply_position",
            "name": "经理"
        },
        {
            "code": "436B",
            "enumid": 1462,
            "keyword": "loanapply_position",
            "name": "副经理"
        },
        {
            "code": "437A",
            "enumid": 1463,
            "keyword": "loanapply_position",
            "name": "分局长"
        },
        {
            "code": "437B",
            "enumid": 1464,
            "keyword": "loanapply_position",
            "name": "副分局长"
        },
        {
            "code": "438A",
            "enumid": 1465,
            "keyword": "loanapply_position",
            "name": "站长"
        },
        {
            "code": "438B",
            "enumid": 1466,
            "keyword": "loanapply_position",
            "name": "副站长"
        },
        {
            "code": "439A",
            "enumid": 1467,
            "keyword": "loanapply_position",
            "name": "厂长"
        },
        {
            "code": "439B",
            "enumid": 1468,
            "keyword": "loanapply_position",
            "name": "副厂长"
        },
        {
            "code": "440A",
            "enumid": 1469,
            "keyword": "loanapply_position",
            "name": "场长"
        },
        {
            "code": "133Q",
            "enumid": 1504,
            "keyword": "loanapply_position",
            "name": "总会计师"
        }
    ],
    "zhiye": [{
            "code": "11",
            "enumid": 370043,
            "keyword": "loanapply_occupation",
            "name": "国家公务员"
        },
        {
            "code": "13",
            "enumid": 370044,
            "keyword": "loanapply_occupation",
            "name": "专业技术人员"
        },
        {
            "code": "17",
            "enumid": 370045,
            "keyword": "loanapply_occupation",
            "name": "职员"
        },
        {
            "code": "21",
            "enumid": 370046,
            "keyword": "loanapply_occupation",
            "name": "企业管理人员"
        },
        {
            "code": "24",
            "enumid": 370041,
            "keyword": "loanapply_occupation",
            "name": "工人"
        },
        {
            "code": "27",
            "enumid": 370047,
            "keyword": "loanapply_occupation",
            "name": "农民"
        },
        {
            "code": "37",
            "enumid": 370049,
            "keyword": "loanapply_occupation",
            "name": "现役军人"
        },
        {
            "code": "51",
            "enumid": 370050,
            "keyword": "loanapply_occupation",
            "name": "自由职业者"
        },
        {
            "code": "54",
            "enumid": 370051,
            "keyword": "loanapply_occupation",
            "name": "个体经营者"
        },
        {
            "code": "70",
            "enumid": 370052,
            "keyword": "loanapply_occupation",
            "name": "无业人员"
        },
        {
            "code": "90",
            "enumid": 370054,
            "keyword": "loanapply_occupation",
            "name": "其他"
        }
    ],
    "zjlx": [{
            "code": "01",
            "enumid": 1,
            "keyword": "cust_1",
            "name": "身份证"
        },
        {
            "code": "02",
            "enumid": 2,
            "keyword": "cust_1",
            "name": "军官证"
        },
        {
            "code": "03",
            "enumid": 2011,
            "keyword": "cust_1",
            "name": "护照"
        },
        {
            "code": "04",
            "enumid": 2015,
            "keyword": "cust_1",
            "name": "外国人永久居留证"
        },
        {
            "code": "07",
            "enumid": 9232,
            "keyword": "cust_1",
            "name": "台港澳居民通行证"
        },
        {
            "code": "99",
            "enumid": 2012,
            "keyword": "cust_1",
            "name": "其他"
        }
    ],
    dkzt: [
        {code:'5', name:'暂存'},
        {code:'10',name:'申请'},
        {code:'20',name:'受理'},
        {code:'30',name:'审批中'},
        {code:'38',name:'贷款终审通过'},
        {code:'40',name:'制作合同'},
        {code:'43',name:'登记合同完毕'},
        {code:'45',name:'抵押登记完毕'},
        {code:'47',name:'保证金抵押'},
        {code:'48',name:'制订划拨单'},
        {code:'49',name:'划拨审批中或完毕'},
        {code:'50',name:'放款确认'},
        {code:'60',name:'还款'},
        {code:'70',name:'逾期'},
        {code:'72',name:'逾期已结转'},
        {code:'80',name:'还清'},
        {code:'81',name:'已解除'},
        {code:'90',name:'否定'},
        {code:'91',name:'核销'},
    ]
}



// WEBPACK FOOTER //
// ./src/static/js/meiju.json.js